import './css/index';
import YoutubeClassRoom from './js/YoutubeClassRoom';
import './assets/images/not_found.png';
import './assets/images/no_saved_video.png';
import './assets/images/no_watched_video.png';

new YoutubeClassRoom();
